import { render } from "./ArticleUkraineComponent.vue?vue&type=template&id=9c6c7610"
import script from "./ArticleUkraineComponent.vue?vue&type=script&lang=js"
export * from "./ArticleUkraineComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konradmilewski/Projects/AppWorks/janpawelvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__